import { Injectable } from '@angular/core';
import { deflate } from 'zlib';
import { UnionCheckNamePropertyService } from './union-check-name-property.service';
import { ValidatorPropertyHandler } from './validator-property-handler';

@Injectable({
  providedIn: 'root'
})
export class ValidatorHandlerService {
  constructor(private unionCheckService: UnionCheckNamePropertyService) {}
  getValidatorHandler(validatorName: string): ValidatorPropertyHandler<any> {
    switch (validatorName) {
      case 'unionCheck':
        return this.unionCheckService;
      default:
        return;
    }
  }
}
